import React from "react";
import { ProductItem } from "../types/bomTypes";
import { roundValue } from "../../../../../grocery/hooks/useRound";
import CommonTable, { HeadCell } from "../../../../../grocery/components/CommonTable";

interface Props {
  items: ProductItem[];
  editedAmounts?: { [productId: string]: string };
}
interface ProductRow {
  id: number;
  sno: number;
  productName: JSX.Element;
  quantity: string | number;
  itemTotal: string | number;
}

const ProductTable: React.FC<Props> = ({ items, editedAmounts = {} }) => {
  const data: ProductRow[] = items.map((p, index) => {
    const amount = Number(editedAmounts[p.productId] ?? p.unitPrice);

    return {
      id: index + 1,
      sno: index + 1,
      productName: (
        <div className="flex flex-col">
          <span className="text-sm font-medium text-gray-900">{p.productName}</span>
          {p.arabicName && <span className="text-xs text-gray-500 mt-0.5">{p.arabicName}</span>}
        </div>
      ),
      quantity: Number(p.quantity),
      itemTotal: roundValue(amount * Number(p.quantity)),
    };
  });

  const headCells: HeadCell<ProductRow>[] = [
    { id: "sno", label: "S.No" },
    { id: "productName", label: "Product name" },
    // { id: "arabicword", label: "Arabic word" },
    { id: "quantity", label: "QTY", numeric: true },
    { id: "itemTotal", label: "Amount (QAR)", numeric: true },
  ];

  return (
    <CommonTable
      title='Products'
      showToolbar={false}
      data={data}
      headCells={headCells}
      selectable={false}
      denseToggle={true}
      pagenation={true}
      className='w-full min-w-[530px] h-[350px]'
    />
  );
};

export default ProductTable;
